var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMatic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.85 13.475 4.743-2.739a.816.816 0 0 0 .407-.705V4.553c0-.29-.156-.56-.407-.705l-4.744-2.74a.817.817 0 0 0-.814 0l-4.744 2.74a.816.816 0 0 0-.406.705v9.79l-3.327 1.92-3.327-1.92V10.5l3.327-1.92 2.194 1.266V7.27L5.965 6.24a.816.816 0 0 0-.814 0L.407 8.978A.816.816 0 0 0 0 9.683v5.478c0 .29.156.56.407.705l4.744 2.74a.82.82 0 0 0 .814 0l4.744-2.74a.816.816 0 0 0 .406-.704v-9.79l.06-.034 3.267-1.887 3.327 1.92v3.842l-3.327 1.92-2.19-1.264v2.577l1.783 1.03a.819.819 0 0 0 .814 0Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMatic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/matic.8b4da47a03ab9486f537f9ae31f11c2d.svg";